define('viewModels/privileged/qm/policies/editors/ArchiveDurationAction',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'extensions/knockout.validation.extender',
    'lib/knockout.validation'
], function (_, ko, $, ViewModel) {
    'use strict';
    var ArchiveDurationAction= ViewModel.extend(function (durationObservable, target) {
        var self = this;
        var MILLISECONDS_PER_DAY = 86400000;
        var STORAGE_MEDIUM = "cloudArchive";

        self.durationAmount = ko.observable(0).extend({min: 1});

        if (!ko.isObservable(durationObservable)) {
            throw "durationObservable must be an observable!";
        }
        var duration = durationObservable;

        /**
         * @returns {object}
         */
        var cloudObjects = function(){

            /**
             * @param durationValue : number
             * @returns {void}
             */
            var convertDuration = function(durationValue){
                self.durationAmount(durationValue.days()  * MILLISECONDS_PER_DAY);
            };

            /**
             * @param cloudDuration : number
             * @returns {object}
             */
            var updateDurationValue = function (cloudDuration) {
                if (_.isUndefined(cloudDuration)) {
                    cloudDuration = 0;
                }

                return {days: convertMillisecondsToDays(cloudDuration)};
            };

            /**
             * @param millisecondValue : number
             * @returns {number}
             */
            function convertMillisecondsToDays(millisecondValue){
                return Math.floor(millisecondValue / MILLISECONDS_PER_DAY);
            }

            return {
                archiveRetention: {
                    convertDuration: convertDuration,
                    updateDuration: function(cloudDuration){
                        var tempObj = updateDurationValue(cloudDuration);
                        tempObj.storageMedium = STORAGE_MEDIUM;
                        duration(tempObj);
                    }
                },
                deleteRetention: {
                    convertDuration: convertDuration,
                    updateDuration: function(cloudDuration){
                        duration(updateDurationValue(cloudDuration));
                    }
                }
            };
        };

        //if there is a duration, unwrap the target value
        if (duration()){
            if (duration().days){
                cloudObjects()[target].convertDuration(ko.unwrap(duration()));
            }
        }

        self.computed(function () {
            cloudObjects()[target].updateDuration(self.durationAmount());
        });

    });
    return ArchiveDurationAction;
});

